import React from "react";
import AgraniHeader from "./AgraniHeader";
import AgraniFooter from "./AgraniFooter";
import CustomNav from "./CustomNav";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <CustomNav />
      <section
        className="position-relative text-white text-center mt-5"
        style={{
          backgroundImage: "url('/assets/img/bg-imagee.avif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "80px 0",
        }}
      >
        <div className="">
          <h1 className="fw-bold display-4 text-orange">PRIVACY POLICY</h1>
          <div className="mt-2 d-flex  justify-content-center gap-2">
            <Link to="/" className="text-black">
              Home{" "}
            </Link>{" "}
            <span className="text-black">/</span>
            <p className="text-light"> Privacy</p>
          </div>
        </div>
      </section>
      <main className="flex-grow-1 container mt-5  ">
        <p>
          This Privacy Policy governs the manner in which LeadsConnect collects,
          uses, maintains and discloses information collected from users (each,
          a “User”) of the{" "}
          <a
            href="https://www.leadsconnect.in"
            target="_blank"
            rel="noreferrer"
          >
            https://www.leadsconnect.in
          </a>{" "}
          website (‘Site’), AGRANI, AGRANI Pro, AGRANI Kisan & AGRANI Saathi
          Android Applications. This privacy policy applies to the Site and all
          products and services offered by LeadsConnect.
        </p>

        <h5 className="mt-4">Personal identification information</h5>
        <p>
          We may collect personal identification information from Users in a
          variety of ways, including, but not limited to, when Users visit our
          site, register on the site, place an order, subscribe to the
          newsletter, respond to a survey, fill out a form, and in connection
          with other activities, services, features or resources we make
          available on our Site. Users may be asked for, as appropriate: name,
          email address, mailing address, phone number, location data, credit
          card information. Users may visit our Site anonymously. We collect
          personal info only if voluntarily submitted. Refusing may prevent
          participation in certain activities.
        </p>

        <h5 className="mt-4">Non-personal identification information</h5>
        <p>
          We may collect non-personal identification information about Users
          whenever they interact with our Site. This includes browser name, type
          of computer, technical information about the means of connection to
          our Site, such as OS and Internet service provider, etc.
        </p>

        <h5 className="mt-4">Web browser cookies</h5>
        <p>
          Our Site may use “cookies” to enhance User experience. Users can set
          their web browser to refuse cookies or alert when cookies are being
          sent. Some parts of the Site may not function properly without them.
        </p>

        <h5 className="mt-4">How we use collected information</h5>
        <ul>
          <li>To improve customer service</li>
          <li>To personalize user experience</li>
          <li>To improve our Site and services</li>
          <li>To process payments (only what's necessary)</li>
          <li>
            To share some anonymous information with third-party advertising
            companies
          </li>
          <li>
            To run promotions, contests, surveys, and send relevant content
          </li>
          <li>
            To send periodic emails regarding orders or updates if subscribed
          </li>
          <li>To collect and use location data via the app for geo-tagging</li>
        </ul>

        <h5 className="mt-4">How we protect your information</h5>
        <p>
          We use appropriate data collection, storage, and security measures to
          protect against unauthorized access, alteration, disclosure, or
          destruction of your personal data. SSL encryption and digital
          signatures are in place.
        </p>

        <h5 className="mt-4">Sharing your personal information</h5>
        <p>
          We may use trusted third-party service providers (like newsletters or
          surveys) to help operate the business and website. This is only done
          with your permission and for specific purposes.
        </p>

        <h5 className="mt-4">Third-party websites</h5>
        <p>
          Our site may contain links to insurance providers and other services.
          We are not responsible for the privacy practices or content on those
          external sites. Use of such websites is at your own discretion and
          subject to their terms.
        </p>

        <h5 className="mt-4">Changes to this privacy policy</h5>
        <p>
          LeadsConnect may update this privacy policy at any time. Users will be
          notified via email and the updated date will be posted on this page.
          We encourage Users to regularly review this policy.
        </p>

        <h5 className="mt-4">Your acceptance of these terms</h5>
        <p>
          By using this Site, you agree to this policy. If you do not agree,
          please do not use the Site. Continued use following any changes will
          be deemed acceptance of those changes.
        </p>

        <p className="text-muted mt-4">
          Last updated: <strong>June 26, 2025</strong>
        </p>
      </main>

      <AgraniFooter />
    </div>
  );
};

export default PrivacyPolicy;
